export default __webpack_public_path__ + "static/media/EW.454044ba.pdf";